import React, { useEffect } from 'react';
import { motion } from 'framer-motion'; // Import motion for animations
import { archivistData } from '../ProData';

const AboutView = () => {

  useEffect(() => {
    document.title = "About - Jesuit Madurai Province Archives (JEMPARC)";  
    window.scrollTo(0, 0);
    document.body.classList.add('about');
  }, []);
  
  const containerStyle = {
    fontFamily: '"Inter", sans-serif',
    backgroundColor: '#ffffff', // Clean white background
    borderRadius: '1.5rem', // Rounded corners for a modern feel
    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)', // Stronger, elegant shadow
    padding: '2.5rem', // Generous padding
    maxWidth: '900px', // Max width for readability
    margin: '2rem auto', // Center the block and add vertical margin
    border: '1px solid #e2e8f0', // Subtle light border
    lineHeight: '1.8', // Increased line height for better readability
    color: '#4a5568', // Dark grey text for good contrast
    fontSize: '1.05rem', // Slightly larger base font size
  };

  const paragraphStyle = {
    textAlign: 'justify',
    marginBottom: '1.5rem', // Space between paragraphs
  };

  const linkStyle = {
    color: '#4f46e5', // Indigo color for links
    fontWeight: '600',
    textDecoration: 'none',
    transition: 'color 0.2s ease-in-out',
  };

  // --- New Styles for Archivists Section ---
  const archivistSectionStyle = {
    marginTop: '3rem', // Space above this new section
    paddingTop: '2rem',
    borderTop: '1px solid #e2e8f0', // Separator line
  };

  const archivistHeaderStyle = {
    fontSize: '2rem', // text-3xl
    fontWeight: '800', // font-extrabold
    color: '#2d3748', // Darker text for header
    marginBottom: '2rem', // mb-8
    textAlign: 'center',
    textShadow: '2px 2px 4px rgba(0,0,0,0.05)',
  };

  const archivistGridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', // Responsive columns
    gap: '1.5rem', // Space between archivist cards
  };

  const archivistCardStyle = {
    backgroundColor: '#f7fafc', // Light grey background for the card
    borderRadius: '1rem', // Rounded corners
    boxShadow: '0 5px 15px -3px rgba(0,0,0,0.1), 0 2px 8px -2px rgba(0,0,0,0.05)', // Subtle shadow
    padding: '1.5rem', // Padding inside the card
    border: '1px solid #e0e7ff', // Light indigo border
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between', // Push content to top/bottom
    transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
  };

  const archivistNameStyle = {
    fontSize: '1.25rem', // text-xl
    fontWeight: '700', // font-bold
    color: '#4f46e5', // Indigo color for names
    marginBottom: '0.5rem',
  };

  const archivistTenureStyle = {
    fontSize: '0.95rem',
    color: '#718096', // Grey color for tenure
    marginBottom: '1rem', // Space before description if any
  };

  const archivistDescriptionStyle = {
    fontSize: '0.9rem',
    color: '#6366f1', // Slightly different shade for special notes
    fontStyle: 'italic',
    marginTop: '0.5rem',
    lineHeight: '1.5',
  };

  const checkmarkStyle = {
    color: '#10b981', // Green checkmark icon
    marginRight: '0.5rem',
    fontSize: '1.2rem',
  };

  // Avatar styles for archivist photo / initial fallback
  const avatarWrapperStyle = {
    flexShrink: 0,
    width: '64px',
    height: '64px',
    borderRadius: '9999px',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#e2e8f0',
    border: '1px solid #cbd5e1',
  };

  const avatarStyle = {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block',
  };

  const avatarFallbackStyle = {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.25rem',
    fontWeight: '700',
    color: '#ffffff',
    background: '#4f46e5',
  };


  return (
    <div style={containerStyle}>
     {/* <p style={paragraphStyle}>
        <strong>Jesuits!</strong> <br />
        Jesuits are members of the <strong>Society of Jesus (SJ)</strong>, one of the largest Religious Congregations for men in the Catholic Church. The Society of Jesus was founded by <strong>St. Ignatius of Loyola</strong>, a Spanish soldier, who, like most men of his time, initially dreamed of bravery, fame, wealth and women. After being wounded in a battle he underwent a terrible surgery. While he was convalescing, he took to reading the lives of Saints which completely transformed him. He wanted to serve God - not the king. For the greater glory of God <strong><em>Ad majorem Dei gloriam</em></strong> became his motto. Jesuits travelled to all parts of the world to proclaim the good news of Jesus. Realizing the vital role that education plays in humanizing the society, they founded Schools and Colleges and offered not merely academic education, but also discipline and human values. Apart from education, they worked in various fields - science, communication, social action, philosophy and theology, spirituality... all for God's greater glory.
      </p>
      <p style={paragraphStyle}>
        Today more than <strong>16,000 Jesuits</strong> work in <strong>112 countries</strong> in six continents, with the aim of moulding, with God’s grace, <strong>men and women for others.</strong> They see themselves as converted sinners or wounded healers and understand their mission in the world as <strong>service of faith and promotion of justice.</strong> The present Superior General is the charming, serene <strong>Fr. Arturo Sosa SJ.</strong> To learn more about Jesuits worldwide, visit... <a href="http://www.sjweb.info" target="_blank" rel="noopener noreferrer" style={linkStyle}>www.sjweb.info</a>
      </p>*/}
      <h3 style={archivistHeaderStyle}>Jesuit Madurai Province Archives and Directors</h3>
      <p style={paragraphStyle}>
        <strong>Society of Jesus </strong> was founded in Rome by <strong>St. Ignatius of Loyola in 1540 </strong>. In 1542 Fr.Francis Xavier, bosom friend of Ignatius was in Tamil Nadu proclaiming the word of God. In 1606, Fr. Robert De Nobili established the Old Madura Mission. Fr. Beschi, John De Britto, and many other Jesuits spread Christianity in old Madura Mission. Society of Jesus was suppressed in 1773 and was restored in 1814.
        </p>
      <p style={paragraphStyle}>
        <strong>New Madura mission</strong> had its beginning in Tamil Nadu in 1837 with Frs Joseph Bertrand, Alexander Martin, Louis Garnierand Louis de Ranquet.From then on New Madurai Mission Jesuits with a new perspective introduced education, medical help and built orphanages and old age homes to help the people. Frs Besse, Trincal, Anglade, Bertrand and Jerome D’Souza had given a good start and New Madura mission had which was part of <strong> Toulouse Province, France emerged as Jesuit Madurai Province (1952). In course of time Jesuit Madurai Province gave birth to Kerala Province (1983), Andhra Province (1988), and Chennai Province (2019).</strong>
       </p>
      <p style={paragraphStyle}>
        <strong>More than 500 Jesuits are working in Tamil Nadu in various ministries.</strong> Our mission is to build people  through value based primary, secondary and higher education, working with Tribals, underprivileged  and women in their growth having the motto <strong>“Ad Majorem Dei Glorium” AMDG - For the greater glory of God.</strong> Through technical education, media awareness, spiritual empowerment and pastoral involvement, we offer our service to improve the quality of people by fighting against caste system, fundamentalism, illiteracy and economic disparity that still oppresses people. Knowing the Lord, loving the Lord and following the Lord is the pathway to be fruitful in our mission.
        </p>
      <p style={paragraphStyle}>
        Jesuit Madurai Province Archives speaks volumes about the Jesuits mission socio, economic, political and cultural life of people of Tamil Nadu from 17th century onwards.
You are most welcome to our Archives to do research after going through the catalogue available in the same website.
        </p>

      {/* --- New Archivists Section --- */}
      <div style={archivistSectionStyle}>
        <h3 style={archivistHeaderStyle}>List of Archivists: </h3>
        <div style={archivistGridStyle}>
          {archivistData.map((archivist, index) => (
            <motion.div
              key={index}
              style={archivistCardStyle}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.05 }}
              whileHover={{ scale: 1.03, boxShadow: '0 8px 25px -5px rgba(0,0,0,0.15)' }}
            >
              <div style={{display: 'flex', alignItems: 'center'}}>
                <div style={avatarWrapperStyle}>
                  {archivist.photo ? (
                    <img src={archivist.photo} alt={archivist.name} style={avatarStyle} />
                  ) : (
                    <div style={avatarFallbackStyle}>
                      {/*archivist.name ? archivist.name.trim().charAt(0) : '?'*/}
                      {archivist.name && archivist.name.includes('.') 
  ? archivist.name.split('.').pop().charAt(1) 
  : (archivist.name ? archivist.name.trim().charAt(0) : '?')}
                    </div>
                  )}
                </div>

                <div style={{marginLeft: '1rem', flex: 1}}>
                  <h4 style={archivistNameStyle}>
                    {/*<span style={checkmarkStyle}>✔</span>*/}{archivist.name}
                  </h4>
                  <p style={archivistTenureStyle}>
                    Tenure: <strong>{archivist.tenure}</strong>
                  </p>
                  {archivist.note && (
                    <p style={archivistDescriptionStyle}>{archivist.note}</p>
                  )}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AboutView;
